import React, { use } from "react";
import {
  StyledIconButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterList from "@mui/icons-material/FilterList";
import { useState } from "react";
import { StyledFormControl } from "../../../components/StyledComponents/Inputs/Inputs.js";
import {
  StyledDialog,
  StyledDialogTitle,
} from "../../../components/StyledComponents/Dialog/Dialog.js";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";
import {
  H5HeadlineMedium,
  H6HeadlineSmall,
  H8TitleMedium,
  BodyMedium,
} from "../../../components/StyledComponents/Typography/Typography.tsx";
import {
  CircularProgress,
  DialogContent,
  FormControl,
  Stack,
  DialogActions,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import {
  StyledCheckbox,
  StyledTextField,
} from "../../../components/StyledComponents/Inputs/Inputs.js";

import useAppContextProvider from "../../../AppContext/useAppContextProvider.js";
import useMinerPageContext from "../../context/useMinerPageContext.js";
import useSiteAndGroupTreeContext from "../../context/useSiteAndGroupTreeContext.js";
import { useSiteCommands } from "../../queries/useSiteCommands.ts";

import { useTransferMiners } from "../../queries/useTransferMiners.ts";
import { useDeleteMiners } from "../../queries/useDeleteMiners.ts";
import { Query, QueryClient } from "@tanstack/react-query";
import { useHistory } from "react-router-dom";
import { set } from "lodash";
import StyledSwitch from "../../../components/StyledComponents/Switch/Switch.js";

const CustomTHSForm = (props) => {
  const { maxths, maxpower, refetch, setTableKey } = props;
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const { colors } = useTheme();
  const {
    selectedSerials,
    setCustomizationModalOpen,
    customizationModalOpen,
    groupFilters,
    setStepperOpen,
    setJobId,
    fluxVisionTuning,
    setFluxVisionTuning,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const {
    mutate: SendCommands,
    isPending,
    isSuccess,
  } = useSiteCommands();

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      ths: "",
    },
  });

  const onSubmit = (data) => {
    const { ths } = data;
    const command = {
      command: "fvmode",
      mode: "custom",
      tune: "ths",
      ths: isNaN(parseInt(ths)) ? 0 : parseInt(ths),
    };
    SendCommands(
      {
        siteName: siteSelectedName,
        serials: selectedSerials,
        commands: command,
        filter: {
          ...groupFilters,
          ...(groupSelectedName !== ""
            ? { dgname: groupSelectedName }
            : {}),
          ...(siteSelectedName !== ""
            ? { siteName: siteSelectedName }
            : {}),
        },
        fvTuning: fluxVisionTuning,
      },
      {
        onSuccess: async (response) => {
          console.log("response", response);
          if (response.status === "ok") {
            await refetch();
            setTableKey((prev) => prev + 1);
            setCustomizationModalOpen(false);
            if (response?.jobid) {
              // navigate.push(`/jobDetails?jobID=${response?.jobid}`);
              setStepperOpen(true);
              setJobId(response?.jobid);
            }
          } else {
            setCustomizationModalOpen(false);
            setToastMessage(
              `Error sending miner commands: ${response.msg}`
            );
            setToastOpen(true);
            setCustomizationModalOpen(false);
          }
        },
        onError: (error) => {
          setToastMessage(
            "Error sending Custom THS command"
          );
          setToastOpen(true);
        },
      }
    );
    reset();
  };

  const onFluxVisionTuningChange = (event) => {
    setFluxVisionTuning(event.target.checked);
  };

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      open={customizationModalOpen}
      hideBackdrop
    >
      <StyledDialogTitle sx={{ paddingTop: 0 }}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <H5HeadlineMedium style={{ textAlign: "left" }}>
            Custom THs
          </H5HeadlineMedium>
          <StyledIconButton
            colors={colors}
            onClick={() => {
              setCustomizationModalOpen(false);
            }}
            style={{ textAlign: "right" }}
          >
            <CloseIcon />
          </StyledIconButton>
        </Box>
      </StyledDialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={8}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={4}
              className="url-details-container"
            >
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <H8TitleMedium>Custom THs</H8TitleMedium>
              </Box>

              <Box
                display="flex"
                flexDirection="row"
                flexGrow={1}
              >
                <StyledFormControl colors={colors} fullWidth margin="none">
                  <Controller
                    name="ths"
                    control={control}
                    rules={{
                      required: "THs value is required",
                      min: {
                        value: 30,
                        message: "Minimum value is 30",
                      },
                      max: {
                        value: maxths,
                        message: `Maximum value is ${maxths}`,
                      },
                      validate: (value) => {
                        if (value) {
                          if (
                            !(
                              parseInt(value) >= 30 &&
                              parseInt(value) <= maxths
                            )
                          ) {
                            return `Custom THs must be between 30 and ${maxths}`;
                          }
                        }
                        return true;
                      },
                    }}
                    render={({ field }) => (
                      <StyledTextField colors={colors}
                        {...field}
                        variant="outlined"
                        type="number"
                        label="THs"
                        fullWidth
                        onChange={(event) =>
                          field.onChange(event.target.value)
                        }
                        error={Boolean(errors.ths)}
                        helperText={
                          errors.ths
                            ? errors.ths.message
                            : `Custom THs can be between 30 and ${maxths}`
                        }
                      />
                    )}
                  />
                </StyledFormControl>
              </Box>

              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={2}
                // padding={"0.5rem"}
              >
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  flexGrow={1}
                  alignItems={"center"}
                >
                  <H8TitleMedium>
                    {" "}
                    FluxVision Tuning
                  </H8TitleMedium>
                  <StyledSwitch
                    colors={colors}
                    checked={fluxVisionTuning}
                    onChange={onFluxVisionTuningChange}
                    defaultChecked={true}
                  />
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                  gap={2}
                >
                  {/* <span className="material-symbols-outlined">
                report
              </span> */}
                  {fluxVisionTuning ? (
                    <BodyMedium>
                      FluxVision Tuning mode is enabled,
                      meaning this command will override
                      local tuning settings.
                    </BodyMedium>
                  ) : (
                    <BodyMedium>
                      FluxVision Tuning mode is disabled,
                      meaning this command may be overridden
                      by local tuning settings.
                    </BodyMedium>
                  )}
                </Box>
              </Box>
              <BodyMedium>
                <b>Note:</b> Please make sure to verify the
                supported hashrate range for your specific
                miner model.
              </BodyMedium>
            </Box>

            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-end"}
              gap={4}
              className="action-button-container"
            >
              <PrimaryButton colors={colors}
                type="submit"
                onClick={handleSubmit(onSubmit)}
                disabled={!isValid || isPending}
                endIcon={
                  isPending && (
                    <CircularProgress
                      size={24}
                      sx={{ color: colors.primary.main }}
                    />
                  )
                }
              >
                {isPending
                  ? "Submitting..."
                  : isSuccess
                  ? "Submitted"
                  : "Submit"}
              </PrimaryButton>
            </Box>
          </Box>
        </form>
      </DialogContent>
    </StyledDialog>
  );
};

const CustomPowerForm = (props) => {
  const { maxpower, refetch, setTableKey } = props;
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const { colors } = useTheme();
  const {
    selectedSerials,
    setCustomPowerModalOpen,
    customPowerModalOpen,
    groupFilters,
    setJobId,
    setStepperOpen,
    fluxVisionTuning,
    setFluxVisionTuning,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const {
    mutate: SendCommands,
    isPending,
    isSuccess,
  } = useSiteCommands();
  const navigate = useHistory();

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      power: "",
    },
  });

  //set values to when

  const power = watch("power");
  const onSubmit = (data) => {
    const { power } = data;
    const command = {
      command: "fvmode",
      mode: "custom",
      tune: "power",
      power:
        isNaN(parseInt(power)) === true
          ? 0
          : parseInt(power),
    };
    SendCommands(
      {
        siteName: siteSelectedName,
        serials: selectedSerials,
        commands: command,
        filter: {
          ...groupFilters,
          ...(groupSelectedName !== ""
            ? { dgname: groupSelectedName }
            : {}),
          ...(siteSelectedName !== ""
            ? { siteName: siteSelectedName }
            : {}),
        },
        fvTuning: fluxVisionTuning,
      },
      {
        onSuccess: async (response) => {
          console.log("response", response);
          if (response.status === "ok") {
            await refetch();
            setTableKey((prev) => prev + 1);
            setCustomPowerModalOpen(false);
            if (response?.jobid) {
              setJobId(response?.jobid);
              setStepperOpen(true);
            }
          } else {
            setCustomPowerModalOpen(false);
            setToastMessage(
              `Error sending miner commands: ${response.msg}`
            );
            setToastOpen(true);
          }
        },
        onError: (error) => {
          setToastMessage(
            "Error sending custom power command"
          );
          setToastOpen(true);
        },
      }
    );
    reset();
  };

  const onFluxVisionTuningChange = (event) => {
    setFluxVisionTuning(event.target.checked);
  };

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      open={customPowerModalOpen}
      hideBackdrop
    >
      <StyledDialogTitle sx={{ paddingTop: 0 }}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <H5HeadlineMedium style={{ textAlign: "left" }}>
            Custom Power
          </H5HeadlineMedium>
          <StyledIconButton
            colors={colors}
            onClick={() => {
              setCustomPowerModalOpen(false);
            }}
            style={{ textAlign: "right" }}
          >
            <CloseIcon />
          </StyledIconButton>
        </Box>
      </StyledDialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={8}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={4}
              className="url-details-container"
            >
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <H8TitleMedium>Custom Power</H8TitleMedium>
              </Box>
              <Box
                display="flex"
                flexDirection="row"
                flexGrow={1}
              >
                <StyledFormControl colors={colors} fullWidth margin="none">
                  <Controller
                    name="power"
                    control={control}
                    rules={{
                      min: {
                        value: 1000,
                        message: "Minimum value is 1000",
                      },
                      max: {
                        value: maxpower,
                        message: `Maximum value is ${maxpower}`,
                      },
                      validate: (value) => {
                        if (
                          !(
                            parseInt(value) >= 1000 &&
                            parseInt(value) <= maxpower
                          )
                        ) {
                          return `Custom power must be between 1000 and ${maxpower}`;
                        }
                        return true;
                      },
                    }}
                    render={({ field }) => (
                      <StyledTextField colors={colors}
                        {...field}
                        variant="outlined"
                        label="Power in watts"
                        fullWidth
                        type="number"
                        onChange={(event) =>
                          field.onChange(event.target.value)
                        }
                        error={Boolean(errors.power)}
                        helperText={
                          errors.power
                            ? errors.power.message
                            : `Custom power can be between 1000 and ${maxpower}`
                        }
                      />
                    )}
                  />
                </StyledFormControl>
              </Box>
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={2}
                // padding={"0.5rem"}
              >
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  flexGrow={1}
                  alignItems={"center"}
                >
                  <H8TitleMedium>
                    {" "}
                    FluxVision Tuning
                  </H8TitleMedium>
                  <StyledSwitch
                    colors={colors}
                    checked={fluxVisionTuning}
                    onChange={onFluxVisionTuningChange}
                    defaultChecked={true}
                  />
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                  gap={2}
                >
                  {/* <span className="material-symbols-outlined">
                report
              </span> */}
                  {fluxVisionTuning ? (
                    <BodyMedium>
                      FluxVision Tuning mode is enabled,
                      meaning this command will override
                      local tuning settings.
                    </BodyMedium>
                  ) : (
                    <BodyMedium>
                      FluxVision Tuning mode is disabled,
                      meaning this command may be overridden
                      by local tuning settings.
                    </BodyMedium>
                  )}
                </Box>
              </Box>
              <BodyMedium>
                <b>Note:</b> Please make sure to verify the
                supported power range for your specific
                miner model.
              </BodyMedium>
            </Box>

            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-end"}
              gap={4}
              className="action-button-container"
            >
              <PrimaryButton colors={colors}
                type="submit"
                disabled={!isValid || isPending}
                onClick={handleSubmit(onSubmit)}
              >
                {isPending
                  ? "Submitting..."
                  : isSuccess
                  ? "Submitted"
                  : "Submit"}
              </PrimaryButton>
            </Box>
          </Box>
        </form>
      </DialogContent>
    </StyledDialog>
  );
};

const CustomRetuneForm = (props) => {
  const { refetch, setTableKey } = props;
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const { colors } = useTheme();
  const {
    selectedSerials,
    setRetuneModalOpen,
    retuneModalOpen,
    groupFilters,
    setStepperOpen,
    setJobId,
    fluxVisionTuning,
    setFluxVisionTuning,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const {
    mutate: SendCommands,
    isPending,
    isSuccess,
  } = useSiteCommands();
  const navigate = useHistory();

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      retuneTime: "",
    },
  });

  //set values to when

  const onSubmit = (data) => {
    const { retuneTime } = data;
    const command = {
      command: "fvmode",
      reTuneTime:
        isNaN(parseInt(retuneTime)) === true
          ? 0
          : parseInt(retuneTime),
    };
    SendCommands(
      {
        siteName: siteSelectedName,
        serials: selectedSerials,
        commands: command,
        filter: {
          ...groupFilters,
          ...(groupSelectedName !== ""
            ? { dgname: groupSelectedName }
            : {}),
          ...(siteSelectedName !== ""
            ? { siteName: siteSelectedName }
            : {}),
        },
        fvTuning: fluxVisionTuning,
      },
      {
        onSuccess: async (response) => {
          console.log("response", response);
          if (response.status === "ok") {
            await refetch();
            setTableKey((prev) => prev + 1);
            setRetuneModalOpen(false);
            if (response?.jobid) {
              setJobId(response?.jobid);
              setStepperOpen(true);
            }
          } else {
            setRetuneModalOpen(false);
            setToastMessage(
              `Error sending miner commands: ${response.msg}`
            );
            setToastOpen(true);
          }
        },
        onError: (error) => {
          setToastMessage(
            "Error sending custom retune command"
          );
          setToastOpen(true);
        },
      }
    );
    reset();
  };

  const onFluxVisionTuningChange = (event) => {
    setFluxVisionTuning(event.target.checked);
  };

  const retuneTime = watch("retuneTime");

  return (
    <>
      <StyledDialog
        colors={colors}
        maxWidth={"md"}
        fullWidth
        open={retuneModalOpen}
        hideBackdrop
      >
        <StyledDialogTitle sx={{ paddingTop: 0 }}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
          >
            <H5HeadlineMedium style={{ textAlign: "left" }}>
              Retune miners
            </H5HeadlineMedium>
            <StyledIconButton
              colors={colors}
              onClick={() => {
                setRetuneModalOpen(false);
              }}
              style={{ textAlign: "right" }}
            >
              <CloseIcon />
            </StyledIconButton>
          </Box>
        </StyledDialogTitle>
        <DialogContent sx={{ padding: 0 }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={8}
            >
              <Box
                display={"flex"}
                flexDirection={"column"}
                gap={4}
                className="url-details-container"
              >
                <Box
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <H8TitleMedium>
                    Set the minimum time interval between
                    automatic retunes
                  </H8TitleMedium>
                </Box>
                <Box
                  display="flex"
                  flexDirection="row"
                  flexGrow={1}
                >
                  <StyledFormControl colors={colors} fullWidth margin="none">
                    <Controller
                      name="retuneTime"
                      control={control}
                      rules={{
                        min: {
                          value: 30,
                          message:
                            "Minimum value is 30 minutes",
                        },
                        max: {
                          value: 2880,
                          message:
                            "Maximum value is 2880 minutes",
                        },
                        validate: (value) => {
                          if (
                            !(
                              parseInt(value) >= 30 &&
                              parseInt(value) <= 2880
                            )
                          ) {
                            return "Custom power must be between 30 and 2880 minutes";
                          }
                          return true;
                        },
                      }}
                      render={({ field }) => (
                        <StyledTextField colors={colors}
                          {...field}
                          variant="outlined"
                          label="Time interval in minutes"
                          fullWidth
                          type="number"
                          onChange={(event) =>
                            field.onChange(
                              event.target.value
                            )
                          }
                          error={Boolean(errors.retuneTime)}
                          helperText={
                            errors.retuneTime
                              ? errors.retuneTime.message
                              : "Enter time interval beteween 30 and 2880 minutes"
                          }
                        />
                      )}
                    />
                  </StyledFormControl>
                </Box>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={2}
                  // padding={"0.5rem"}
                >
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    flexGrow={1}
                    alignItems={"center"}
                  >
                    <H8TitleMedium>
                      {" "}
                      FluxVision Tuning
                    </H8TitleMedium>
                    <StyledSwitch
                      colors={colors}
                      checked={fluxVisionTuning}
                      onChange={onFluxVisionTuningChange}
                      defaultChecked={true}
                    />
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    gap={2}
                  >
                    {/* <span className="material-symbols-outlined">
                report
              </span> */}
                    {fluxVisionTuning ? (
                      <BodyMedium>
                        FluxVision Tuning mode is enabled,
                        meaning this command will override
                        local system configuration.
                      </BodyMedium>
                    ) : (
                      <BodyMedium>
                        FluxVision Tuning mode is disabled,
                        meaning this command may be
                        overridden by local system
                        configuration.
                      </BodyMedium>
                    )}
                  </Box>
                </Box>
                <BodyMedium>
                  <b>Note:</b> This operation requires miner
                  firmware v2.0.0 or later.
                </BodyMedium>
              </Box>

              <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-end"}
                gap={4}
                className="action-button-container"
              >
                <PrimaryButton colors={colors}
                  type="submit"
                  disabled={!isValid || isPending}
                  onClick={handleSubmit(onSubmit)}
                  endIcon={
                    isPending && (
                      <CircularProgress
                        size={24}
                        sx={{ color: colors?.primary?.main }}
                      />
                    )
                  }
                >
                  {isPending
                    ? "Submitting..."
                    : isSuccess
                    ? "Submitted"
                    : "Submit"}
                </PrimaryButton>
              </Box>
            </Box>
          </form>
        </DialogContent>
      </StyledDialog>
    </>
  );
};

const EcoDialog = ({
  setMinerConfigurationModalOpen,
  setWhichMinerConfigurationForm,
  refetch,
  setTableKey,
}) => {
  const {
    mutate: SendCommands,
    isPending,
    isSuccess,
  } = useSiteCommands();
  const {
    selectedSerials,
    groupFilters,
    setJobId,
    setStepperOpen,
    ecoModalOpen,
    setEcoModalOpen,
    fluxVisionTuning,
    setFluxVisionTuning,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const navigate = useHistory();

  const onSubmit = () => {
    SendCommands(
      {
        commands: {
          command: "fvmode",
          mode: "eco",
        },
        serials: selectedSerials,
        siteName: siteSelectedName,
        filter: {
          ...groupFilters,
          ...(groupSelectedName !== ""
            ? { dgname: groupSelectedName }
            : {}),
          ...(siteSelectedName !== ""
            ? { siteName: siteSelectedName }
            : {}),
        },
        fvTuning: fluxVisionTuning,
      },
      {
        onSuccess: async (response) => {
          if (response.status === "ok") {
            await refetch();
            setTableKey((prev) => prev + 1);
            if (response?.jobid) {
              setEcoModalOpen(false);
              setStepperOpen(true);
              setJobId(response?.jobid);
              // navigate.push(`/jobDetails?jobID=${response?.jobid}`);
            }
          } else {
            setEcoModalOpen(false);
            setToastMessage(
              `Error sending miner commands: ${response.msg}`
            );
            setToastOpen(true);
          }
        },
        onError: (error) => {
          setEcoModalOpen(false);
          setToastMessage(
            `Error sending miner commands: ${error}`
          );
          setToastOpen(true);
        },
      }
    );
    setEcoModalOpen(false);
  };

  const onFluxVisionTuningChange = (event) => {
    setFluxVisionTuning(event.target.checked);
  };

  const { colors } = useTheme();

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      hideBackdrop
      open={ecoModalOpen}
      onClose={() => setEcoModalOpen(false)}
      sx={{ overflowX: "hidden" }}
      padding={"1.5rem"}
    >
      <StyledDialogTitle>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          flexGrow={1}
          paddingLeft={"0.5rem"}
        >
          <H6HeadlineSmall style={{ textAlign: "left" }}>
            Eco
          </H6HeadlineSmall>
          <StyledIconButton
            colors={colors}
            onClick={() => {
              setEcoModalOpen(false);
            }}
          >
            <CloseIcon />
          </StyledIconButton>
        </Box>
      </StyledDialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <Box
          display="flex"
          flexDirection={"column"}
          gap={2}
          paddingTop={"1rem"}
          paddingBottom={"1rem"}
        >
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            padding={"0.5rem"}
          >
            <H8TitleMedium>
              Energy-efficient operation with reduced power
              consumption
            </H8TitleMedium>
          </Box>

          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={2}
            padding={"0.5rem"}
          >
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              flexGrow={1}
              alignItems={"center"}
            >
              <H8TitleMedium>
                {" "}
                FluxVision Tuning
              </H8TitleMedium>
              <StyledSwitch
                colors={colors}
                checked={fluxVisionTuning}
                onChange={onFluxVisionTuningChange}
                defaultChecked={true}
              />
            </Box>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={2}
            >
              {/* <span className="material-symbols-outlined">
                report
              </span> */}
              {fluxVisionTuning ? (
                <BodyMedium>
                  FluxVision Tuning mode is enabled, meaning
                  this command will override local tuning
                  settings.
                </BodyMedium>
              ) : (
                <BodyMedium>
                  FluxVision Tuning mode is disabled,
                  meaning this command may be overridden by
                  local tuning settings.
                </BodyMedium>
              )}
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <PrimaryButton colors={colors}
          type="submit"
          disabled={isPending}
          onClick={onSubmit}
          endIcon={
            isPending && (
              <CircularProgress
                size={24}
                sx={{ color: colors.primary.main }}
              />
            )
          }
        >
          {isPending ? "Submitting..." : "Submit"}
        </PrimaryButton>
      </DialogActions>
    </StyledDialog>
  );
};

const TurboDialog = ({
  setMinerConfigurationModalOpen,
  setWhichMinerConfigurationForm,
  refetch,
  setTableKey,
}) => {
  const {
    mutate: SendCommands,
    isPending,
    isSuccess,
  } = useSiteCommands();
  const {
    selectedSerials,
    groupFilters,
    setJobId,
    setStepperOpen,
    turboModalOpen,
    setTurboModalOpen,
    fluxVisionTuning,
    setFluxVisionTuning,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const navigate = useHistory();

  const onSubmit = () => {
    SendCommands(
      {
        commands: {
          command: "fvmode",
          mode: "turbo",
        },
        serials: selectedSerials,
        siteName: siteSelectedName,
        filter: {
          ...groupFilters,
          ...(groupSelectedName !== ""
            ? { dgname: groupSelectedName }
            : {}),
          ...(siteSelectedName !== ""
            ? { siteName: siteSelectedName }
            : {}),
        },
        fvTuning: fluxVisionTuning,
      },
      {
        onSuccess: async (response) => {
          if (response.status === "ok") {
            setTurboModalOpen(false);
            await refetch();
            setTableKey((prev) => prev + 1);
            if (response?.jobid) {
              setStepperOpen(true);
              setJobId(response?.jobid);
              // navigate.push(`/jobDetails?jobID=${response?.jobid}`);
            }
          } else {
            setTurboModalOpen(false);
            setToastMessage(
              `Error sending miner commands: ${response.msg}`
            );
            setToastOpen(true);
          }
        },
        onError: (error) => {
          setToastMessage(
            `Error sending miner commands: ${error}`
          );
          setToastOpen(true);
          setTurboModalOpen(false);
        },
      }
    );
    setTurboModalOpen(false);
  };

  const onFluxVisionTuningChange = (event) => {
    setFluxVisionTuning(event.target.checked);
  };

  const { colors } = useTheme();

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      hideBackdrop
      open={turboModalOpen}
      onClose={() => setTurboModalOpen(false)}
      sx={{ overflowX: "hidden" }}
      padding={"1.5rem"}
    >
      <StyledDialogTitle>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
          flexGrow={1}
          paddingLeft={"0.5rem"}
        >
          <H6HeadlineSmall style={{ textAlign: "left" }}>
            Turbo
          </H6HeadlineSmall>
          <StyledIconButton
            colors={colors}
            onClick={() => {
              setTurboModalOpen(false);
            }}
          >
            <CloseIcon />
          </StyledIconButton>
        </Box>
      </StyledDialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <Box
          display="flex"
          flexDirection={"column"}
          gap={2}
          paddingTop={"1rem"}
          paddingBottom={"1rem"}
        >
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            padding={"0.5rem"}
          >
            <H8TitleMedium>
              Full-capacity operation for maximum hash rate
            </H8TitleMedium>
          </Box>
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={2}
            padding={"0.5rem"}
          >
            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              flexGrow={1}
              alignItems={"center"}
            >
              <H8TitleMedium>
                {" "}
                FluxVision Tuning
              </H8TitleMedium>
              <StyledSwitch
                colors={colors}
                checked={fluxVisionTuning}
                onChange={onFluxVisionTuningChange}
                defaultChecked={true}
              />
            </Box>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={2}
            >
              {/* <span className="material-symbols-outlined">
                report
              </span> */}
              {fluxVisionTuning ? (
                <BodyMedium>
                  FluxVision Tuning mode is enabled, meaning
                  this command will override local tuning
                  settings.
                </BodyMedium>
              ) : (
                <BodyMedium>
                  FluxVision Tuning mode is disabled,
                  meaning this command may be overridden by
                  local tuning settings.
                </BodyMedium>
              )}
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <PrimaryButton colors={colors}
          disabled={isPending}
          onClick={onSubmit}
          endIcon={
            isPending && (
              <CircularProgress
                size={24}
                sx={{ color: colors.primary.main }}
              />
            )
          }
        >
          {isPending ? "Submitting..." : "Submit"}
        </PrimaryButton>
      </DialogActions>
    </StyledDialog>
  );
};

const RestartDialog = (props) => {
  const { refetch, setTableKey } = props;
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const {
    selectedSerials,
    setRestartModalOpen,
    restartModalOpen,
    groupFilters,
    setJobId,
    setStepperOpen,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const {
    mutate: sendMinerCommands,
    isPending,
    isSuccess,
  } = useSiteCommands();
  const navigate = useHistory();

  const onSubmit = () => {
    sendMinerCommands(
      {
        serials: selectedSerials,
        siteName: siteSelectedName,
        commands: {
          command: "restart",
        },
        filter: {
          ...groupFilters,
          ...(groupSelectedName !== ""
            ? { dgname: groupSelectedName }
            : {}),
          ...(siteSelectedName !== ""
            ? { siteName: siteSelectedName }
            : {}),
        },
      },
      {
        onSuccess: async (response) => {
          if (response.status === "ok") {
            await refetch();
            setTableKey((prev) => prev + 1);
            setRestartModalOpen(false);
            if (response?.jobid) {
              // navigate.push(
              //   `/jobDetails?jobID=${response?.jobid}`
              // );
              setStepperOpen(true);
              setJobId(response?.jobid);
            }
          } else {
            setToastMessage(
              `Error sending miner commands: ${response.msg}`
            );
            setToastOpen(true);
            setRestartModalOpen(false);
          }
        },
        onError: (error) => {
          setToastMessage(
            `Error sending miner commands: ${error}`
          );
          setToastOpen(true);
          setRestartModalOpen(false);
        },
      }
    );
    setRestartModalOpen(false);
  };

  const { colors } = useTheme();

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      hideBackdrop
      open={restartModalOpen}
      onClose={() => setRestartModalOpen(false)}
      sx={{ overflowX: "hidden" }}
      padding={"1.5rem"}
    >
      <StyledDialogTitle>
        <H6HeadlineSmall style={{ textAlign: "left" }}>
          Restart Miners
        </H6HeadlineSmall>
      </StyledDialogTitle>
      <DialogContent
        sx={{ padding: 0, overflowX: "hidden" }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={6}
          marginTop={1}
        >
          <BodyMedium>
            Restarting will suspend all functions
            momentarily while the system reboots.
          </BodyMedium>
          <BodyMedium>
            Are you sure you want to proceed with the
            restart?
          </BodyMedium>
          <Box
            display={"flex"}
            flexDirection={"row"}
            gap={4}
            justifyContent={"flex-end"}
          >
            <SecondaryButton colors={colors}
              onClick={() => setRestartModalOpen(false)}
            >
              Cancel
            </SecondaryButton>
            <PrimaryButton colors={colors}
              disabled={isPending}
              sx={{ padding: "1rem" }}
              onClick={() => {
                onSubmit();
              }}
              endIcon={
                isPending && (
                  <CircularProgress
                    size={24}
                    sx={{ color: colors.primary.main }}
                  />
                )
              }
            >
              {isPending ? "Restarting..." : "Restart"}
            </PrimaryButton>
          </Box>
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};

const TransferMinerForm = ({ refetch, setTableKey }) => {
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const {
    selectedSerials,
    setTransferModalOpen,
    transferModalOpen,
    groupFilters,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const {
    mutate: submitTransfer,
    isPending,
    isSuccess,
  } = useTransferMiners();

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      organizationId: "",
      superAdminEmail: "",
    },
  });

  //set values to when

  const onSubmit = (data) => {
    const { organizationId, superAdminEmail } = data;

    submitTransfer(
      {
        siteName: siteSelectedName,
        dgname: groupSelectedName,
        serials: selectedSerials,
        target_email: superAdminEmail,
        target_org_name: organizationId,
        filter: {},
      },
      {
        onSuccess: async (response) => {
          console.log("response", response);
          if (response.status === "ok") {
            setToastMessage(
              "Transfer of miners initiated successfully"
            );
            setToastOpen(true);
            setTransferModalOpen(false);
            await refetch();
            setTableKey((prev) => prev + 1);
          } else {
            setToastMessage(
              `Failed to transfer miners: ${response.msg}`
            );
            setToastOpen(true);
            setTransferModalOpen(false);
          }
        },
        onError: (error) => {
          setToastMessage(
            `Failed to transfer miners: ${error}`
          );
          setToastOpen(true);
        },
      }
    );
    reset();
  };

  const organizationId = watch("organizationId");
  const superAdminEmail = watch("superAdminEmail");

  const { colors } = useTheme();

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      open={transferModalOpen}
      hideBackdrop
    >
      <StyledDialogTitle sx={{ paddingTop: 0 }}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"space-between"}
        >
          <H5HeadlineMedium style={{ textAlign: "left" }}>
            Transfer miners
          </H5HeadlineMedium>
          <StyledIconButton
            colors={colors}
            onClick={() => {
              setTransferModalOpen(false);
            }}
            style={{ textAlign: "right" }}
          >
            <CloseIcon />
          </StyledIconButton>
        </Box>
      </StyledDialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={8}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={4}
              className="target-organization-container"
            >
              <H8TitleMedium>
                Target organization ID
              </H8TitleMedium>
              <Box
                display="flex"
                flexDirection="row"
                flexGrow={1}
              >
                <StyledFormControl colors={colors} fullWidth margin="none">
                  <Controller
                    name="organizationId"
                    control={control}
                    rules={{
                      required:
                        "Organization ID is required",
                    }}
                    render={({ field }) => (
                      <StyledTextField colors={colors}
                        {...field}
                        variant="outlined"
                        label="Organization ID"
                        fullWidth
                        onChange={(event) =>
                          field.onChange(event.target.value)
                        }
                      />
                    )}
                  />
                </StyledFormControl>
              </Box>
            </Box>
            <Box
              display={"flex"}
              flexDirection={"column"}
              gap={4}
              className="super-admin-email-container"
            >
              <H8TitleMedium>
                Target superadmin email
              </H8TitleMedium>
              <Box
                display="flex"
                flexDirection="row"
                flexGrow={1}
              >
                <StyledFormControl colors={colors} fullWidth margin="none">
                  <Controller
                    name="superAdminEmail"
                    control={control}
                    rules={{
                      required:
                        "Super admin email is required",
                      validate: (value) => {
                        const emailRegex =
                          /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (!emailRegex.test(value)) {
                          return "Please enter a valid email address";
                        }
                        return true;
                      },
                    }}
                    render={({ field }) => (
                      <StyledTextField colors={colors}
                        {...field}
                        variant="outlined"
                        label="Super admin email"
                        fullWidth
                        onChange={(event) =>
                          field.onChange(event.target.value)
                        }
                        error={Boolean(
                          errors.superAdminEmail
                        )}
                        helperText={
                          errors.superAdminEmail
                            ? errors.superAdminEmail.message
                            : "Enter the email of the super admin"
                        }
                      />
                    )}
                  />
                </StyledFormControl>
              </Box>
            </Box>

            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"flex-end"}
              gap={4}
              className="action-button-container"
            >
              <PrimaryButton colors={colors}
                disabled={
                  organizationId === "" ||
                  superAdminEmail === "" ||
                  !isValid ||
                  isPending
                }
                onClick={handleSubmit(onSubmit)}
                type="submit"
                endIcon={
                  isPending && (
                    <CircularProgress
                      size={24}
                      sx={{ color: colors.primary.main }}
                    />
                  )
                }
              >
                {isPending
                  ? "Submitting..."
                  : isSuccess
                  ? "Submitted"
                  : "Submit"}
              </PrimaryButton>
            </Box>
          </Box>
        </form>
      </DialogContent>
    </StyledDialog>
  );
};

const DeleteMinersDialog = ({ open, setOpen, refetch }) => {
  const deleteMinerHandler = () => {
    deleteMiner(
      {
        siteName: siteSelectedName,
        dgname: groupSelectedName,
        serials: selectedSerials,
      },
      {
        onSuccess: async (response) => {
          console.log("response", response);
          if (response.status === "ok") {
            setToastMessage("Miners deleted successfully");
            setToastOpen(true);
            setOpen(false);
            await refetch();
          } else {
            setToastMessage(
              "Failed to delete miners: " + response.msg
            );
            await refetch();

            setToastOpen(true);
            setOpen(false);
          }
        },
        onError: (error) => {
          setToastMessage(
            "Error sending delete miners command"
          );
          setToastOpen(true);
        },
      }
    );
  };

  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const { selectedSerials, groupFilters } =
    useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const { mutate: deleteMiner } = useDeleteMiners();

  const handleClose = () => {
    setOpen(false);
  };

  const { colors } = useTheme();

  return (
    <StyledDialog
      colors={colors}
      maxWidth="sm"
      hideBackdrop
      open={open}
      onClose={handleClose}
      sx={{ overflowX: "hidden" }}
      padding={"1.5rem"}
    >
      <StyledDialogTitle>
        <H6HeadlineSmall style={{ textAlign: "left" }}>
          Delete Miners ?
        </H6HeadlineSmall>
      </StyledDialogTitle>
      <DialogContent
        sx={{ padding: 0, overflowX: "hidden" }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={6}
          marginTop={1}
        >
          <BodyMedium>
            This action is permanent and cannot be undone.
            If you're unsure, click "cancel" to cancel this
            operation. Once removed, miners cannot be
            recovered through the UI. To restore them,
            please contact the Auradine Support Team.
          </BodyMedium>
          <Box
            display={"flex"}
            flexDirection={"row"}
            gap={4}
            justifyContent={"flex-end"}
          >
            <SecondaryButton colors={colors} onClick={handleClose}>
              Cancel
            </SecondaryButton>
            <PrimaryButton colors={colors}
              sx={{ padding: "1rem" }}
              onClick={() => {
                deleteMinerHandler();
              }}
            >
              Delete miners
            </PrimaryButton>
          </Box>
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};

const FactoryResetDialog = (props) => {
  const { refetch, setTableKey } = props;
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const {
    selectedSerials,
    setFactoryResetModalOpen,
    factoryResetModalOpen,
    groupFilters,
    setStepperOpen,
    setJobId,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const {
    mutate: SendCommands,
    isPending,
    isSuccess,
  } = useSiteCommands();
  const navigate = useHistory();

  const onSubmit = () => {
    const command = {
      command: "factory-reset",
    };
    SendCommands(
      {
        siteName: siteSelectedName,
        serials: selectedSerials,
        commands: command,
        filter: {
          ...groupFilters,
          ...(groupSelectedName !== ""
            ? { dgname: groupSelectedName }
            : {}),
          ...(siteSelectedName !== ""
            ? { siteName: siteSelectedName }
            : {}),
        },
      },
      {
        onSuccess: async (response) => {
          console.log("response", response);
          if (response.status === "ok") {
            await refetch();
            setTableKey((prev) => prev + 1);
            setFactoryResetModalOpen(false);
            if (response?.jobid) {
              // navigate.push(
              //   `/jobDetails?jobID=${response?.jobid}`
              // );
              setStepperOpen(true);
              setJobId(response?.jobid);
            }
          } else {
            setToastMessage(
              "Failed to send factory-reset command"
            );
            setToastOpen(true);
            setFactoryResetModalOpen(false);
          }
        },
        onError: (error) => {
          setToastMessage(
            "Error sending factory-reset command"
          );
          setToastOpen(true);
        },
      }
    );
  };

  const { colors } = useTheme();

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      hideBackdrop
      open={factoryResetModalOpen}
      onClose={() => setFactoryResetModalOpen(false)}
      sx={{ overflowX: "hidden" }}
      padding={"1.5rem"}
    >
      <StyledDialogTitle>
        <H6HeadlineSmall style={{ textAlign: "left" }}>
          Factory Reset
        </H6HeadlineSmall>
      </StyledDialogTitle>
      <DialogContent
        sx={{ padding: 0, overflowX: "hidden" }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={6}
          marginTop={1}
        >
          <BodyMedium>
            This action will remove all current miner
            configurations and return settings to factory
            defaults.
          </BodyMedium>
          <BodyMedium>
            Are you sure you want to proceed with a factory
            reset?
          </BodyMedium>
          <Box
            display={"flex"}
            flexDirection={"row"}
            gap={4}
            justifyContent={"flex-end"}
          >
            <SecondaryButton colors={colors}
              onClick={() =>
                setFactoryResetModalOpen(false)
              }
            >
              Cancel
            </SecondaryButton>
            <PrimaryButton colors={colors}
              sx={{ padding: "1rem" }}
              onClick={() => {
                onSubmit();
              }}
              endIcon={
                isPending && (
                  <CircularProgress
                    size={24}
                    sx={{ color: colors.primary.main }}
                  />
                )
              }
            >
              {isPending
                  ? "Submitting..."
                  : isSuccess
                  ? "Submitted"
                  : "Submit"}
            </PrimaryButton>
          </Box>
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};

const ResetCurtailSchedulesDialog = (props) => {
  const { refetch, setTableKey } = props;
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const {
    selectedSerials,
    resetCurtailSchedulesModalOpen,
    setResetCurtailSchedulesModalOpen,
    groupFilters,
    setStepperOpen,
    setJobId,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const {
    mutate: SendCommands,
    isPending,
    isSuccess,
  } = useSiteCommands();
  const navigate = useHistory();

  const onSubmit = () => {
    const command = {
      command: "exitpcschedule",
    };
    SendCommands(
      {
        siteName: siteSelectedName,
        serials: selectedSerials,
        commands: command,
        filter: {
          ...groupFilters,
          ...(groupSelectedName !== ""
            ? { dgname: groupSelectedName }
            : {}),
          ...(siteSelectedName !== ""
            ? { siteName: siteSelectedName }
            : {}),
        },
      },
      {
        onSuccess: async (response) => {
          console.log("response", response);
          if (response.status === "ok") {
            await refetch();
            setTableKey((prev) => prev + 1);
            setResetCurtailSchedulesModalOpen(false);
            if (response?.jobid) {
              // navigate.push(
              //   `/jobDetails?jobID=${response?.jobid}`
              // );
              setStepperOpen(true);
              setJobId(response?.jobid);
            }
          } else {
            setToastMessage(
              "Failed to send reset curtail schedules command"
            );
            setToastOpen(true);
            setResetCurtailSchedulesModalOpen(false);
          }
        },
        onError: (error) => {
          setToastMessage(
            "Error sending reset curtail schedules command"
          );
          setToastOpen(true);
        },
      }
    );
  };

  const { colors } = useTheme();

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      hideBackdrop
      open={resetCurtailSchedulesModalOpen}
      onClose={() => setResetCurtailSchedulesModalOpen(false)}
      sx={{ overflowX: "hidden" }}
      padding={"1.5rem"}
    >
      <StyledDialogTitle>
        <H6HeadlineSmall style={{ textAlign: "left" }}>
          Reset Curtail Schedules
        </H6HeadlineSmall>
      </StyledDialogTitle>
      <DialogContent
        sx={{ padding: 0, overflowX: "hidden" }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={6}
          marginTop={1}
        >
          <BodyMedium>
            This is a fail-safe mechanism used only when miners appear to be stuck in Power Curtailment mode.
          </BodyMedium>
          <BodyMedium>
            Are you sure you want to proceed with resetting curtail schedules?
          </BodyMedium>
          <Box
            display={"flex"}
            flexDirection={"row"}
            gap={4}
            justifyContent={"flex-end"}
          >
            <SecondaryButton colors={colors}
              onClick={() =>
                setResetCurtailSchedulesModalOpen(false)
              }
            >
              Cancel
            </SecondaryButton>
            <PrimaryButton colors={colors}
              sx={{ padding: "1rem" }}
              onClick={() => {
                onSubmit();
              }}
              endIcon={
                isPending && (
                  <CircularProgress
                    size={24}
                    sx={{ color: colors.primary.main }}
                  />
                )
              }
            >
              {isPending
                  ? "Submitting..."
                  : isSuccess
                  ? "Submitted"
                  : "Submit"}
            </PrimaryButton>
          </Box>
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};

const ReImageDialog = (props) => {
  const { refetch, setTableKey } = props;
  const { setToastMessage, setToastOpen } =
    useAppContextProvider();
  const {
    selectedSerials,
    reImageModalOpen,
    setReImageModalOpen,
    groupFilters,
    setStepperOpen,
    setJobId,
  } = useMinerPageContext();
  const { siteSelectedName, groupSelectedName } =
    useSiteAndGroupTreeContext();
  const {
    mutate: SendCommands,
    isPending,
    isSuccess,
  } = useSiteCommands();
  const navigate = useHistory();

  const onSubmit = () => {
    const command = {
      command: "reimage",
    };
    SendCommands(
      {
        siteName: siteSelectedName,
        serials: selectedSerials,
        commands: command,
        filter: {
          ...groupFilters,
          ...(groupSelectedName !== ""
            ? { dgname: groupSelectedName }
            : {}),
          ...(siteSelectedName !== ""
            ? { siteName: siteSelectedName }
            : {}),
        },
      },
      {
        onSuccess: async (response) => {
          console.log("response", response);
          if (response.status === "ok") {
            await refetch();
            setTableKey((prev) => prev + 1);
            setReImageModalOpen(false);
            if (response?.jobid) {
              // navigate.push(
              //   `/jobDetails?jobID=${response?.jobid}`
              // );
              setStepperOpen(true);
              setJobId(response?.jobid);
            }
          } else {
            setToastMessage(
              "Failed to send reimage command to recover the boot partition"
            );
            setToastOpen(true);
            setReImageModalOpen(false);
          }
        },
        onError: (error) => {
          setToastMessage(
            "Error sending reimage command to recover the boot partition"
          );
          setToastOpen(true);
        },
      }
    );
  };

  const { colors } = useTheme();

  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      hideBackdrop
      open={reImageModalOpen}
      onClose={() => setReImageModalOpen(false)}
      sx={{ overflowX: "hidden" }}
      padding={"1.5rem"}
    >
      <StyledDialogTitle>
        <H6HeadlineSmall style={{ textAlign: "left" }}>
          Recover Boot Partition
        </H6HeadlineSmall>
      </StyledDialogTitle>
      <DialogContent
        sx={{ padding: 0, overflowX: "hidden" }}
      >
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={6}
          marginTop={1}
        >
          <BodyMedium>
            Use this only if the device fails to boot. This will attempt restore using boot partition.
          </BodyMedium>
          <BodyMedium>
            Are you sure you want to recover using boot partition?
          </BodyMedium>
          <Box
            display={"flex"}
            flexDirection={"row"}
            gap={4}
            justifyContent={"flex-end"}
          >
            <SecondaryButton colors={colors}
              onClick={() =>
                setReImageModalOpen(false)
              }
            >
              Cancel
            </SecondaryButton>
            <PrimaryButton colors={colors}
              sx={{ padding: "1rem" }}
              onClick={() => {
                onSubmit();
              }}
              endIcon={
                isPending && (
                  <CircularProgress
                    size={24}
                    sx={{ color: colors.primary.main }}
                  />
                )
              }
            >
              {isPending
                ? "Reimaging..."
                : isSuccess
                ? "Recover boot partition initated"
                : "Recover boot partition"}
            </PrimaryButton>
          </Box>
        </Box>
      </DialogContent>
    </StyledDialog>
  );
};

export {
  CustomTHSForm,
  CustomPowerForm,
  CustomRetuneForm,
  RestartDialog,
  EcoDialog,
  TurboDialog,
  TransferMinerForm,
  DeleteMinersDialog,
  FactoryResetDialog,
  ResetCurtailSchedulesDialog,
  ReImageDialog
};
